<template>
    <div class="supermessage">
        {{this.supermessage}}
    </div>
</template>

<script>
export default {
    name:'supermessage',
    data() {
        return {
           supermessage:'系统信息'
        }
    },
}
</script>

<style lang="less" scoped>
   .supermessage{
       width: 100%;
       height: 500px;
       background-color: rgb(207, 122, 18);
   }
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/supermessage.vue